import { rankFeature, rankList } from "@/mocks/home";

const rankColor = (i: number) => (i === 0 ? "text-primary-500" : "text-foreground-300");

export default function HeatRank() {
  return (
    <section id="rank" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
          <div>
            <p className="text-xs font-bold tracking-[0.22em] text-accent-700">HEAT RANKING · 实时更新</p>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black tracking-tight text-foreground-950">
              本周翻车热度榜
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              综合围观、弹幕与补刀数排行的现场记录，热度每分钟都在变。
            </p>
          </div>
          <div className="flex items-center gap-2 text-xs text-foreground-500 pb-1">
            <span className="flex h-6 items-center gap-1.5 rounded-full bg-background-50 border border-background-200 px-3 whitespace-nowrap">
              <i className="ri-time-line" />
              更新于 12:47
            </span>
            <span className="flex h-6 items-center gap-1.5 rounded-full bg-accent-50 border border-accent-200 px-3 text-accent-700 whitespace-nowrap">
              <i className="ri-fire-line" />
              热度每分钟刷新
            </span>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-[1.15fr_0.85fr] gap-6">
          <div className="flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50">
            {rankList.map((item, i) => {
              const top = i === 0;
              return (
                <a
                  key={item.title}
                  href="#archive"
                  className={`group flex gap-4 md:gap-5 p-4 md:p-5 hover:bg-background-100 ${
                    i !== rankList.length - 1 ? "border-b border-background-200" : ""
                  }`}
                >
                  <div className={`flex w-9 md:w-11 shrink-0 flex-col items-center justify-center font-heading text-3xl md:text-4xl font-black leading-none ${rankColor(i)}`}>
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span
                        className={`rounded-md px-2 py-0.5 text-[11px] font-semibold whitespace-nowrap ${
                          top
                            ? "bg-primary-500 text-background-50"
                            : "bg-secondary-100 text-secondary-800"
                        }`}
                      >
                        {item.category}
                      </span>
                      <span className={`flex items-center gap-0.5 text-[11px] font-semibold ${item.delta.startsWith("↑") ? "text-accent-700" : "text-foreground-500"}`}>
                        <i className={`${item.delta.startsWith("↑") ? "ri-arrow-up-line" : "ri-arrow-down-line"}`} />
                        {item.delta.slice(1)}
                      </span>
                    </div>
                    <h3 className="mt-1.5 font-heading text-base md:text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                      {item.title}
                    </h3>
                    <p className="mt-1 hidden sm:block text-sm text-foreground-600">{item.summary}</p>
                    <div className="mt-2.5 flex items-center gap-3">
                      <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                        <div
                          className={`h-full rounded-full ${top ? "bg-primary-500" : "bg-secondary-400"}`}
                          style={{ width: `${item.heat}%` }}
                        />
                      </div>
                      <span className="text-xs font-bold text-foreground-800 tabular-nums">热度 {item.heat}</span>
                    </div>
                  </div>
                </a>
              );
            })}
          </div>

          <div className="relative flex flex-col overflow-hidden rounded-xl bg-background-950">
            <img
              src={rankFeature.cover}
              alt={`${rankFeature.title}，51大雷翻车合集爆款`}
              className="absolute inset-0 h-full w-full object-cover object-top opacity-95"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/35 to-background-950/10" />
            <div className="relative mt-auto flex flex-col p-5 md:p-6">
              <span className="self-start rounded-full bg-accent-500 text-foreground-950 px-3 py-1 text-[11px] font-bold whitespace-nowrap">
                <i className="ri-medal-line mr-1" />
                {rankFeature.label}
              </span>
              <h3 className="mt-3 font-heading text-xl md:text-2xl font-black leading-snug text-background-50">
                {rankFeature.title}
              </h3>
              <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-background-50/80">
                <span className="flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-eye-line" />
                  {rankFeature.views}
                </span>
                <span className="flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-calendar-line" />
                  {rankFeature.tag}
                </span>
              </div>
              <a
                href="#archive"
                className="mt-4 inline-flex w-fit items-center gap-1.5 rounded-full bg-background-50 text-foreground-950 px-4 py-2 text-sm font-semibold whitespace-nowrap hover:bg-accent-100"
              >
                去围观
                <i className="ri-arrow-right-line text-base" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}